(function(){
  'use strict';
  if(window.__KDK_HOME_SCROLL_DYNAMIC_2026__)return;
  window.__KDK_HOME_SCROLL_DYNAMIC_2026__=true;

  var preference=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
  var canObserve=typeof IntersectionObserver!=='undefined';
  if(!canObserve)return;

  var sectionObserver=new IntersectionObserver(onSectionVisibility,{threshold:0,rootMargin:'0px 0px -17% 0px'});
  var cardObserver=new IntersectionObserver(onCardVisibility,{threshold:0.14,rootMargin:'0px 0px -9% 0px'});
  var sectionStates=new WeakMap();
  var observedSections=new WeakSet(),observedCards=new WeakSet();
  var visibleImages=new Set();
  var matchRoot=null,matchGrid=null,matchCards=[],matchPage=0,lastMatchChange=0;
  var hero=null,lastHeroChange=0,heroDistance=0,matchDistance=0;
  var lastY=window.scrollY||0,lastDirection='down',framePending=false;

  function reduceMotion(){return !!(preference&&preference.matches);}
  function noBrowsing(root){
    if(!root)return false;
    if(root.contains(document.activeElement)&&document.activeElement!==document.body)return false;
    if(root.querySelector('.kdk-match-2026-card:hover,.kdk-looks-product:hover'))return false;
    return true;
  }
  function pageSize(){return window.innerWidth<650?2:4;}
  function renderMatchPage(){
    if(!matchGrid||!matchCards.length)return;
    var count=Math.min(pageSize(),matchCards.length);
    var first=(matchPage*count)%matchCards.length;
    matchCards.forEach(function(card,index){
      var distance=(index-first+matchCards.length)%matchCards.length;
      card.setAttribute('data-kdk-match-visible',distance<count?'true':'false');
    });
    matchGrid.dataset.kdkMatchPage=String(matchPage);
  }
  function initMatches(){
    var found=document.querySelector('#kdk-perfect-matches');
    if(!found)return;
    if(found!==matchRoot){
      matchRoot=found;
      matchGrid=found.querySelector('[data-kdk-style-grid]');
      matchCards=matchGrid?Array.prototype.slice.call(matchGrid.querySelectorAll('.kdk-match-2026-card')):[];
      matchPage=0;lastMatchChange=0;
      if(matchGrid&&matchCards.length>pageSize()&&!reduceMotion()){
        renderMatchPage();
        matchGrid.classList.add('kdk-scroll-match');
      }
    }
  }
  function changeMatches(direction){
    if(reduceMotion()||!matchGrid||matchCards.length<=pageSize()||matchGrid.classList.contains('is-expanded')||!noBrowsing(matchRoot))return false;
    var now=Date.now();
    if(now-lastMatchChange<1900)return false;
    var maxPages=Math.ceil(matchCards.length/pageSize());
    matchPage=(matchPage+(direction==='up'?-1:1)+maxPages)%maxPages;
    renderMatchPage();
    lastMatchChange=now;
    return true;
  }
  function advanceHero(direction){
    if(reduceMotion()||!hero||!noBrowsing(hero))return false;
    var now=Date.now();
    if(now-lastHeroChange<2800)return false;
    hero.dispatchEvent(new CustomEvent('kdk:scroll-advance',{detail:{direction:direction}}));
    lastHeroChange=now;
    return true;
  }
  function onSectionVisibility(entries){
    entries.forEach(function(entry){
      var el=entry.target,state=sectionStates.get(el);
      if(!state)return;
      if(entry.isIntersecting && !state.inView){
        var now=Date.now();
        state.inView=true;
        if(state.visits>0&&now-state.lastExit>1100){
          if(el===matchRoot)changeMatches(lastDirection);
          if(el===hero)advanceHero(lastDirection);
        }
        state.visits+=1;
        if(el===matchRoot)matchDistance=0;
        if(el===hero)heroDistance=0;
      } else if(!entry.isIntersecting&&state.inView){
        state.inView=false;state.lastExit=Date.now();
      }
    });
  }
  function onCardVisibility(entries){
    if(reduceMotion())return;
    entries.forEach(function(entry){
      var card=entry.target;
      if(entry.isIntersecting && !card.hidden){
        card.classList.add('kdk-scroll-pop');
        if(card.querySelector('.kdk-luxe-products__photo img,.kdk-luxe-categories__photo img,.kdk-match-2026-image img'))visibleImages.add(card);
      }else{
        card.classList.remove('kdk-scroll-pop');
        visibleImages.delete(card);
        card.style.removeProperty('--kdk-photo-drift');
      }
    });
  }
  function trackSection(el){
    if(!el||observedSections.has(el))return;
    observedSections.add(el);
    sectionStates.set(el,{inView:false,visits:0,lastExit:0});
    sectionObserver.observe(el);
  }
  function trackCard(el){
    if(!el||observedCards.has(el))return;
    observedCards.add(el);
    cardObserver.observe(el);
  }
  function init(){
    if(reduceMotion())return;
    hero=document.querySelector('[data-kdk-rotator]');
    initMatches();
    document.documentElement.classList.add('kdk-home-scroll-enabled');
    [hero,matchRoot,document.querySelector('[data-kdk-home-shelf]'),
      document.querySelector('.kdk-luxe-categories'),
      document.querySelector('.kdk-winter'),document.querySelector('.kdk-choice')
    ].forEach(trackSection);
    document.querySelectorAll(
      '.kdk-luxe-products__item,.kdk-luxe-categories__card,.kdk-match-2026-card,'+
      '.kdk-winter__look,.kdk-choice__card,.kdk-luxe-products__editorial,'+
      '.kdk-luxe-products__head,.kdk-match-2026-head,.kdk-luxe-categories .kdk-luxe__section-head,'+
      '.kdk-winter__head,.product-card-item'
    ).forEach(trackCard);
  }
  function onScroll(){
    if(framePending||reduceMotion())return;
    framePending=true;
    requestAnimationFrame(function(){
      framePending=false;
      var y=window.scrollY||0,delta=y-lastY;
      if(Math.abs(delta)>3)lastDirection=delta<0?'up':'down';
      lastY=y;
      var distance=Math.abs(delta),now=Date.now();
      if(distance<1)return;
      if(hero&&sectionStates.get(hero)&&sectionStates.get(hero).inView){
        heroDistance+=distance;
        if(heroDistance>330&&now-lastHeroChange>3500){
          if(advanceHero(lastDirection))heroDistance=0;
        }
      }else heroDistance=0;
      if(matchRoot&&sectionStates.get(matchRoot)&&sectionStates.get(matchRoot).inView){
        matchDistance+=distance;
        // Rotate when the visitor scrolls meaningfully, not every pixel.
        if(matchDistance>Math.max(560,Math.round(window.innerHeight*.8))&&now-lastMatchChange>3600){
          if(changeMatches(lastDirection))matchDistance=0;
        }
      }else matchDistance=0;
      var shown=0;
      visibleImages.forEach(function(card){
        if(shown>=18)return;
        if(!document.contains(card)||card.hidden){visibleImages.delete(card);return;}
        var rect=card.getBoundingClientRect();
        if(rect.bottom<0||rect.top>window.innerHeight)return;
        var center=rect.top+rect.height/2-window.innerHeight/2;
        var drift=Math.round(Math.max(-9,Math.min(9,-center/Math.max(1,window.innerHeight)*19)));
        card.style.setProperty('--kdk-photo-drift',drift+'px');
        shown++;
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){if(matchGrid&&!reduceMotion())renderMatchPage();},{passive:true});
  document.addEventListener('shopify:section:load',init);
  if(preference&&preference.addEventListener){
    preference.addEventListener('change',function(){
      if(preference.matches){
        document.documentElement.classList.remove('kdk-home-scroll-enabled');
        if(matchGrid)matchGrid.classList.remove('kdk-scroll-match');
        visibleImages.forEach(function(card){card.classList.remove('kdk-scroll-pop');card.style.removeProperty('--kdk-photo-drift');});
        visibleImages.clear();
      }else{
        init();
        if(matchGrid&&matchCards.length>pageSize()){renderMatchPage();matchGrid.classList.add('kdk-scroll-match');}
      }
    });
  }
})();